<template>
  <div
    :class="classList"
    @click="onClick"
    tabindex="0"
    @keyup.enter="onClick"
  >
    <slot/>
  </div>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    item: {
      type: Object,
      required: true,
    },
    isSelectedFn: {
      type: Function,
      required: true,
    },
  });

  const emit = defineEmits(['select']);

  const isSelected = computed(() => props.isSelectedFn(props.item));

  const classList = computed(() => {
    const list = ['og-select-result'];

    if (isSelected.value) {
      list.push('og-select-result--selected');
    }

    return list;
  });

  function onClick(event) {
    event.stopPropagation();

    emit('select', props.item);
  }
</script>

